import { Button, CircularProgress, Snackbar } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { useDialogProps } from "legacy-components/dialog/Dialog";
import { useCompactDialog } from "legacy-components/dialog/UseCompactDialog";
import { useAsyncAction } from "modus/components/form/async-actions/AsyncAction";
import ConsentApprovalService from "pages/home/applications/services/ConsentApprovalService";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";

interface ConsentApproverProps {
  resourceId: string;
  reloadNotificationList: () => void;
}

export const ConsentApprover: React.FC<ConsentApproverProps> = ({
  resourceId,
  reloadNotificationList
}) => {
  const currentTeamId = useSelector(
    (state: any) =>
      state?.teamManager?.teams?.currentTeam?.id ??
      sessionStorage.getItem("MY_TEAM_KEY")
  );
const { open, toggle } = useDialogProps();
  const { state, subscribe } = useAsyncAction(() =>
    ConsentApprovalService.approve(
      {
        resourceName: resourceId,
        reason: "approved",
      },
      {
        teamId: currentTeamId,
      }
    ),  {
        map: (value) => {
            
                toggle();
            
            return value;
        },
    }
  );

  const handleSubmit = (event: React.MouseEvent<HTMLButtonElement>) => {
    subscribe();
  };
  
  const reload = () => {
    toggle();
    reloadNotificationList();
  };
 
  return (
    <>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={reload}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <>
          <Alert severity="success" variant="filled" onClose={reload} iconMapping={{
            success: <CheckCircleIcon />,
          }}>
            User Consent is Approved
          </Alert>
        </>
      </Snackbar>
      <Button
        disabled={state?.loading}
        onClick={handleSubmit}
        color="primary"
        variant="contained"
      >
        {state?.loading && <CircularProgress className="action-loader" />}
        Approve
      </Button>
    </>
  );
};
